import PropTypes from 'prop-types'
import { TabContent } from 'react-bootstrap'

import AccessibilityFeaturesPanel from './panels/AccessibilityFeaturesPanel'
import ChaptersPanel from './panels/ChaptersPanel'
import DetailsPanel from './panels/DetailsPanel'
import PackagesPanel from './panels/PackagesPanel'
import TableOfContentsPanel from './panels/TableOfContentsPanel'

const Content = ({ eventKey }) => (
  <div className='pdp_page__content light'>
    <TabContent className='pdp_page__content__wrap'>
      <DetailsPanel eventKey={eventKey} />
      <TableOfContentsPanel eventKey={eventKey} />
      <AccessibilityFeaturesPanel eventKey={eventKey} />
      <PackagesPanel eventKey={eventKey} />
      <ChaptersPanel eventKey={eventKey} />
    </TabContent>
  </div>
)

export default Content

Content.propTypes = {
  eventKey: PropTypes.string.isRequired
}
